export default "__VITE_ASSET__6p1X4wax__"